export default __webpack_public_path__ + "static/media/sort-desc.36522c53.svg";